import { Button, makeStyles } from '@fluentui/react-components';
import React from 'react';
import { Outlet } from 'react-router-dom';
import { Meat } from '../model/Meat';
import { SiteHeader } from './SiteHeader';
import { withStyles } from "./withStyles";
import { slStyles } from "../slStyles";
import { slThemeLight } from '../slTheme';
import { LabeledItem, LabeledItemPositions } from './LabeledItem';
import { ClickEditDelegate, ClickDeleteDelegate } from "../model/ItemDelegates";
import { EditRegular, DeleteRegular } from "@fluentui/react-icons";

export interface MeatItemProps
{
    styles: Record<string, string>;
    meat: Meat;
    onEdit?: ClickEditDelegate<Meat>;
    onDelete?: ClickDeleteDelegate<Meat>;
}

export interface MeatItemState
{
}

const useStyles = makeStyles(
    {
        stackHorizontal:
        {
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between'
        },
        meatContainer:
        {
            ...slStyles.detailContainer,
            rowGap: '2pt'
        },
        meatHeader:
        {
            ...slStyles.detailHeader,
        },
        meatItem:
        {
            ...slStyles.detailBoxed
        },
        meatHeaderHeroText:
        {
            ...slStyles.detailHeaderHeroText
        },
        meatHeaderHero:
        {
            background: slThemeLight.colorNeutralBackground5,
            height: '100%',
            padding: '5pt',
            verticalAlign: 'middle'
        }
    });

export class MeatItemWithoutStyles extends React.Component<MeatItemProps, MeatItemState>
{
    onEdit(event: React.MouseEvent<HTMLButtonElement>)
    {
        if (this.props.onEdit)
            this.props.onEdit(event, this.props.meat);
    }

    onDelete(event: React.MouseEvent<HTMLButtonElement>)
    {
        if (this.props.onDelete)
            this.props.onDelete(event, this.props.meat);
    }

    render()
    {
        const meat = this.props.meat;
        const onEdit = this.onEdit.bind(this);
        const onDelete = this.onDelete.bind(this);

        return (
            <div className={this.props.styles.meatContainer}>
                <div className={this.props.styles.meatHeader}>
                    <div className={this.props.styles.stackHorizontal}>
                        <div className={this.props.styles.meatHeaderHero}>
                            {meat.MeatID}
                        </div>
                        <div>
                            <LabeledItem label="description" text={meat.Description} position={LabeledItemPositions.Below}/>
                        </div>
                    </div>
                    <div>
                        <LabeledItem label="source" text={meat.Source} position={LabeledItemPositions.Below}/>
                    </div>
                    <div>
                        <LabeledItem label="rub/marinade" text={meat.Rub} position={LabeledItemPositions.Below}/>
                    </div>
                    <div>
                        <LabeledItem label="untrimmed" text={meat.UntrimmedGrams} position={LabeledItemPositions.Below}/>
                    </div>
                    <div>
                        <LabeledItem label="trimmed" text={meat.TrimmedGrams} position={LabeledItemPositions.Below}/>
                    </div>
                    <div>
                        {this.props.onEdit && (<Button aria-label="Edit" icon={<EditRegular/>} onClick={onEdit}/>)}
                        {this.props.onDelete && (<Button aria-label="Delete" icon={<DeleteRegular/>} onClick={onDelete}/>)}
                    </div>
                </div>
                <div className={this.props.styles.meatItem}>
                    <LabeledItem border label="Initial Observations" text={meat.InitialObs} position={LabeledItemPositions.Above}/>
                </div>
                <div className={this.props.styles.meatItem}>
                    <LabeledItem border label="Preparation" text={meat.Preparation} position={LabeledItemPositions.Above}/>
                </div>
                <div className={this.props.styles.meatItem}>
                    <LabeledItem border label="Post smoke observations" text={meat.PostSmokeObs} position={LabeledItemPositions.Above}/>
                </div>
            </div>
        );
    }
}

export const MeatItem = withStyles(useStyles, MeatItemWithoutStyles);